import InputMask from 'react-input-mask'

import {
  FormControl,
  FormErrorMessage,
  Input,
  Select,
  Textarea,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormLabel,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { sendContact } from 'services/contato'

import { ArrowForwardIcon } from '@chakra-ui/icons'

import Layout from 'components/Layout/Default'
import Container from 'components/Container'

import * as S from './styles'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Loading from 'pages/components/Loading'
import AlertComponent from 'pages/components/AlertComponent'
import { useRecaptcha } from 'utils/useRecaptcha'

const Contato = () => {
  const { isValid, reply, question } = useRecaptcha()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const router = useRouter()

  const handleClose = () => {
    router.push('/comprar-grama')
    onClose()
  }

  useEffect(() => {
    onOpen()
  }, [onOpen])

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm()

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      const payload = {
        'your-subject': data.assunto,
        'your-email': data.email,
        'your-name': data.nome,
        ...data,
      }
      await sendContact(payload)
      setSuccess(true)
      setError(false)

      window?.scrollTo(0, 0)
      reset()
      setTimeout(() => {
        setSuccess(false)
      }, 5000)
    } catch (error) {
      setError(true)
      setSuccess(false)
      setTimeout(() => {
        setError(false)
        setSuccess(false)
      }, 5000)
    } finally {
      setLoading(false)
    }
  }

  const telefoneRef = register('telefone')
  const celularRef = register('celular')

  const handleTelefoneChange = (e) => {
    telefoneRef?.onChange(e)
  }

  const handleCelularChange = (e) => {
    celularRef?.onChange(e)
  }

  return (
    <Layout
      category="Contato"
      title="Fale Conosco, conheça nossa localização"
      description="Formulário dedicado aos clientes com dúvidas sobre grama, sugestões, reclamações, anúncios, parcerias, vagas de empregos ou assuntos relacionados..."
      keywords="contato sobre grama, dúvidas sobre grama, falar sobre grama, orçamento sobre grama, orçamento de grama, contato para orçar grama, contato sobre preço de grama, contato empresas de grama..."
      categorySize="1.6rem"
    >
      <section>
        <Loading isLoading={loading} />
        <AlertComponent
          show={success}
          title="Formulário Enviado"
          status="success"
          description="Obrigado por entrar em contato, em breve te retornaremos!"
        />

        <AlertComponent
          show={error}
          title="Oops"
          status="error"
          description="Houve um erro ao enviar, tente novamente mais tarde."
        />

        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Deseja enviar Orçamento?</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <p>* Não utilize esse formulário</p>
              <p>Clique no botão abaixo</p>
            </ModalBody>

            <ModalFooter>
              <Button
                variant="solid"
                width="100%"
                colorScheme="blue"
                size="lg"
                onClick={handleClose}
              >
                Enviar orçamento
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Container>
          <S.Map>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14626.120239019925!2d-48.0304943!3d-23.5853158!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c5cdf58eaf1217%3A0xf3df8fe4be0cb4ec!2sCentral%20da%20Grama!5e0!3m2!1spt-BR!2sbr!4v1681262176297!5m2!1spt-BR!2sbr"
              style={{ border: 0, width: '100%', height: '100%' }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </S.Map>
          <S.Flex>
            <S.Left>
              <h2>Envie uma mensagem</h2>
              <S.Form onSubmit={handleSubmit(onSubmit)}>
                <S.Grid gap="24px">
                  <FormControl isInvalid={errors.nome}>
                    <Input
                      {...register('nome', {
                        required: 'Este campo é obrigatório',
                        minLength: {
                          value: 3,
                          message: 'O nome deve ter pelo menos 3 caracteres',
                        },
                      })}
                      type="text"
                      placeholder="Nome"
                    />
                    <FormErrorMessage>
                      {errors.nome && errors.nome.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.assunto}>
                    <Select
                      {...register('assunto', {
                        required: 'Este campo é obrigatório',
                      })}
                      placeholder="Assunto"
                    >
                      <option value="Dúvidas">Dúvidas</option>
                      <option value="Reclamações">Reclamações</option>
                      <option value="Sugestões">Sugestões</option>
                      <option value="Anúncios">Anúncios</option>
                      <option value="Parcerias">Parcerias</option>
                      <option value="Vagas de Empregos">
                        Vagas de Empregos
                      </option>
                      <option value="Outros">Outros</option>
                    </Select>
                    <FormErrorMessage>
                      {errors.assunto && errors.assunto.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.email}>
                    <Input
                      {...register('email', {
                        required: 'Este campo é obrigatório',
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: 'Digite um email válido',
                        },
                      })}
                      type="email"
                      placeholder="Email"
                    />
                    <FormErrorMessage>
                      {errors.email && errors.email.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.confirmarEmail}>
                    <Input
                      {...register('confirmarEmail', {
                        validate: (value) =>
                          value === getValues('email') ||
                          'Os emails não correspondem',
                      })}
                      type="email"
                      placeholder="Confirme seu email"
                    />
                    <FormErrorMessage>
                      {errors.confirmarEmail && errors.confirmarEmail.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.telefone}>
                    <InputMask
                      mask="(99) 9999-9999"
                      maskChar=""
                      onChange={handleTelefoneChange}
                      value={telefoneRef.value}
                      {...register('telefone', {
                        required: 'Este campo é obrigatório',
                      })}
                    >
                      {() => (
                        <Input
                          type="tel"
                          placeholder="Telefone"
                          name="telefone"
                        />
                      )}
                    </InputMask>

                    <FormErrorMessage>
                      {errors.telefone && errors.telefone.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.celular}>
                    <InputMask
                      mask="(99) 9 9999-9999"
                      maskChar=""
                      onChange={handleCelularChange}
                      value={celularRef.value}
                      {...register('celular', {
                        required: 'Este campo é obrigatório',
                      })}
                    >
                      {() => (
                        <Input
                          type="tel"
                          placeholder="Celular"
                          name="celular"
                        />
                      )}
                    </InputMask>
                    <FormErrorMessage>
                      {errors.celular && errors.celular.message}
                    </FormErrorMessage>
                  </FormControl>
                </S.Grid>
                <FormControl isInvalid={errors.mensagem} mt="24px">
                  <Textarea
                    {...register('mensagem', {
                      required: 'Este campo é obrigatório',
                    })}
                    placeholder="Mensagem"
                    resize="none"
                  />
                  <FormErrorMessage>
                    {errors.mensagem && errors.mensagem.message}
                  </FormErrorMessage>
                </FormControl>

                <FormControl mt="24px" isInvalid={!isValid()}>
                  <FormLabel>{question}</FormLabel>

                  <Input
                    type="text"
                    placeholder="Digite aqui a resposta"
                    onChange={(event) => reply(event.target.value)}
                  />
                  <FormErrorMessage>
                    Por favor, responda a questão acima.
                  </FormErrorMessage>
                </FormControl>

                <S.Button disabled={!isValid() || loading} shape="rounded">
                  Enviar mensagem <ArrowForwardIcon w={4} h={4} />
                </S.Button>
              </S.Form>
            </S.Left>
            <S.Right>
              <S.About>
                <h4>Contate-nos</h4>
                <S.Item>
                  <S.IconWrap>
                    <svg
                      width="26"
                      height="34"
                      viewBox="0 0 26 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.0019 19.3437C11.8432 19.3437 10.7105 19.0001 9.74709 18.3564C8.78367 17.7126 8.03278 16.7977 7.58937 15.7272C7.14596 14.6567 7.02994 13.4788 7.25599 12.3423C7.48204 11.2059 8.04 10.162 8.85932 9.34271C9.67864 8.52339 10.7225 7.96543 11.8589 7.73938C12.9954 7.51333 14.1733 7.62934 15.2438 8.07276C16.3143 8.51617 17.2292 9.26706 17.873 10.2305C18.5167 11.1939 18.8603 12.3266 18.8603 13.4852C18.8584 15.0384 18.2406 16.5275 17.1424 17.6257C16.0441 18.724 14.5551 19.3418 13.0019 19.3437ZM13.0019 9.97019C12.3067 9.97019 11.627 10.1763 11.049 10.5626C10.471 10.9488 10.0204 11.4978 9.75437 12.1401C9.48832 12.7824 9.41871 13.4891 9.55434 14.171C9.68997 14.8529 10.0247 15.4792 10.5163 15.9708C11.0079 16.4624 11.6343 16.7971 12.3161 16.9328C12.998 17.0684 13.7047 16.9988 14.347 16.7327C14.9893 16.4667 15.5383 16.0162 15.9245 15.4381C16.3108 14.8601 16.5169 14.1805 16.5169 13.4852C16.516 12.5533 16.1454 11.6598 15.4864 11.0008C14.8274 10.3418 13.9338 9.97112 13.0019 9.97019Z"
                        fill="#10B981"
                      />
                      <path
                        d="M13.0019 33.4039L3.1175 21.7468C2.98016 21.5718 2.84424 21.3956 2.70976 21.2184C1.02133 18.9943 0.109202 16.2776 0.113295 13.4852C0.113295 10.067 1.47119 6.78873 3.88827 4.37165C6.30535 1.95458 9.5836 0.59668 13.0019 0.59668C16.4201 0.59668 19.6984 1.95458 22.1155 4.37165C24.5325 6.78873 25.8904 10.067 25.8904 13.4852C25.8945 16.2764 24.9828 18.9918 23.2951 21.2149L23.294 21.2184C23.294 21.2184 22.9425 21.68 22.8897 21.7421L13.0019 33.4039ZM4.57977 19.8065C4.58211 19.8065 4.85395 20.1674 4.91605 20.2447L13.0019 29.7811L21.0982 20.2318C21.1498 20.1674 21.424 19.8042 21.4251 19.803C22.8044 17.9858 23.5498 15.7666 23.5471 13.4852C23.5471 10.6885 22.436 8.00628 20.4584 6.02867C18.4808 4.05106 15.7986 2.94006 13.0019 2.94006C10.2051 2.94006 7.52289 4.05106 5.54529 6.02867C3.56768 8.00628 2.45667 10.6885 2.45667 13.4852C2.45421 15.768 3.19926 17.9885 4.57977 19.8065Z"
                        fill="#10B981"
                      />
                    </svg>
                  </S.IconWrap>
                  <S.Label>Localização</S.Label>
                  <S.Text>Itapetininga/SP</S.Text>
                </S.Item>
                <S.Item>
                  <S.IconWrap>
                    <svg
                      width="20"
                      height="30"
                      viewBox="0 0 20 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.4531 0H4.54403C2.2804 0 0.453125 1.82727 0.453125 4.09091V25.9091C0.453125 28.1727 2.2804 30 4.54403 30H15.4531C17.7168 30 19.544 28.1727 19.544 25.9091V4.09091C19.544 1.82727 17.7168 0 15.4531 0ZM16.8168 23.1818H3.1804V4.09091H16.8168V23.1818ZM12.7259 27.2727H7.27131V25.9091H12.7259V27.2727Z"
                        fill="#10B981"
                      />
                    </svg>
                  </S.IconWrap>
                  <S.Label>Telefone</S.Label>
                  <S.Text>(11) 9 9617-2172</S.Text>
                </S.Item>
              </S.About>
            </S.Right>
          </S.Flex>
        </Container>
      </section>
    </Layout>
  )
}

export default Contato
